import { createUseQueryHook } from '@iheartjane/react-query-utils';

import type { SpecialQualifyingStatusProps } from './storeSpecial.api';
import { fetchSpecialQualifyingStatus } from './storeSpecial.api';
import type { SpecialQualifyingStatus } from './storeSpecial.types';

const QUALIFYING_STATUS_BASE_KEY = 'qualifyingStatus';

const qualifyingStatusKeys = {
  specialQualifyingStatus: (props: SpecialQualifyingStatusProps) => [
    QUALIFYING_STATUS_BASE_KEY,
    'stores',
    'specials',
    String(props.storeId),
    String(props.specialId),
    String(props.cartUuid),
  ],
};

export const useGetSpecialQualifyingStatus = createUseQueryHook<
  SpecialQualifyingStatusProps,
  SpecialQualifyingStatus
>(
  fetchSpecialQualifyingStatus,
  qualifyingStatusKeys.specialQualifyingStatus,
  (props) => !!props.cartUuid && !!props.specialId && !!props.storeId
);
